export const SUB_NAV_SECTIONS = {
  budget: {
    items: [
      { key: 'budgets', labelKey: 'budgets.title.budgets' },
      { key: 'concepts', labelKey: 'budgets.title.concepts' },
    ],
    storageKey: 'homeownerAssociationPinnedBudgetSections',
  },
  buildings: {
    items: [
      { key: 'general', labelKey: 'general' },
      { key: 'units', labelKey: 'units' },
      { key: 'suppliers', labelKey: '_buildingSuppliers.title' },
      { key: 'assets', labelKey: '_assets.title_other' },
      { key: 'documents', labelKey: 'documents' },
      { key: 'relations', labelKey: 'contactsAndCompanies' },
    ],
    storageKey: 'homeownerAssociationPinnedBuildingsSections',
  },
  debtors: {
    items: [
      { key: 'general', labelKey: '_hoaDebtorsOverview.tabs.overview' },
      { key: 'trackings', labelKey: '_hoaDebtorsOverview.tabs.trackings' },
    ],
    storageKey: 'homeownerAssociationPinnedDebtorsSections',
  },
  directDebit: {
    items: [
      { key: 'mandates', labelKey: '_hoaMandates.title' },
      { key: 'logs', labelKey: '_hoaMandateLogs.title' },
      { key: 'settings', labelKey: 'settings' },
    ],
    storageKey: 'homeownerAssociationPinnedDirectDebitSections',
  },
  documents: {
    items: [
      { key: 'reporting', labelKey: 'reports.preview.tabTitle' },
      { key: 'documents', labelKey: 'documents' },
      { key: 'reports', labelKey: 'reports.title' },
    ],
    storageKey: 'homeownerAssociationPinnedDocumentsSections',
  },
  meetings: {
    items: [
      { key: 'meetings', labelKey: '_meeting.title_other' },
      { key: 'settings', labelKey: '_homeownerAssociation.meetingTypeSettings.title' },
    ],
    storageKey: 'homeownerAssociationPinnedMeetingsSections',
  },
  meterReadings: {
    items: [
      { key: 'readings', labelKey: '_meterReadings.title' },
      { key: 'settings', labelKey: '_meterReadingSettings.title' },
    ],
    storageKey: 'homeownerAssociationPinnedMeterReadingsSections',
  },
  payments: {
    items: [
      { key: 'open', labelKey: '_envelopes.title_other' },
      { key: 'archive', labelKey: '_envelopes.archive.title' },
    ],
    storageKey: 'homeownerAssociationPinnedPaymentsSections',
  },
  provisions: {
    items: [
      { key: 'requests', labelKey: '_provisionRequest.title' },
      { key: 'capitals', labelKey: 'reports.types.overviewOfCapitals' },
    ],
    storageKey: 'homeownerAssociationPinnedProvisionsSections',
  },
  settings: {
    items: [
      { key: 'division-keys', labelKey: 'divisionKeys' },
      { key: 'responsibilities', labelKey: '_userResponsibility.title_other' },
      { key: 'accounting-settings', labelKey: '_homeownerAssociationAccountingSettings.title' },
      { key: 'gla', labelKey: 'generalLedgerAccounts' },
      { key: 'booking-rules', labelKey: '_homeownerAssociationBookingRules.title_other' },
      { key: 'board', labelKey: '_homeownerAssociationBoardMembers.titleTable' },
      { key: 'reminders', labelKey: '_financialSettings.paymentSettings.tabTitle' },
      { key: 'financial-accounts', labelKey: '_financialSettings.financialAccounts.tabTitle' },
      {
        key: 'automatic-reconciliations',
        labelKey: '_financialSettings.automaticReconciliationSettings.tabTitle',
      },
      { key: 'cost-reallocations', labelKey: '_homeownerAssociationCostReallocations.title_other' },
    ],
    storageKey: 'homeownerAssociationPinnedSettingsSections',
  },
  syndicManagement: {
    items: [
      { key: 'additional-performances', labelKey: 'additionalPerformances' },
      { key: 'standard-performances', labelKey: '_standardPerformance.title' },
      { key: 'contracts', labelKey: 'contracts' },
    ],
    storageKey: 'homeownerAssociationPinnedSyndicManagementSections',
  },
} as const;

export type SubNavSectionKey = keyof typeof SUB_NAV_SECTIONS;
